/** @format */

import React, { FC, useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {

  useAuthContext,
  useHandleSubmitEditDetails,
} from "senf-shared";
import senfManCelebrating from "../../../../assets/illustrations/senfManCelebrating.png";

import Dropdown from "../../../core/dropdown/Dropdown";
import { useSocialLinks } from "../../socialmediaShare/SocialmediaShare";
import Button from "../../../core/button/Button";

interface UpdatedUser {
  newsletter: boolean;
}

interface SuccessProps {
  successTitle: string;
  successDescription: string;
  successSubtitle: string;
  buttons: Any[];
}

const SenfManCelebratingImg = styled.img`
  z-index: 3;
  pointer-events: none;
  user-select: none;
  top: 20px;
  width: 240px;
  margin-inline: auto;
  transform: translateX(40px);
`;

const Success: FC<SuccessProps> = ({ project, ideaMap, data, handle }) => {
  const { t } = useTranslation();
  const { user, setUser } = useAuthContext();
  const { socialLinks } = useSocialLinks();

  const [updatedUser, setUpdatedUser] = useState<UpdatedUser | null>(null);

  const handleToggleNewsletter = async () => {
    setUpdatedUser({ ...user, newsletter: !user?.newsletter });
  };

  useEffect(() => {
    if (updatedUser) {
      useHandleSubmitEditDetails(updatedUser);
      setUser(updatedUser);
    }
  }, [updatedUser]);

  return (
    <div className="h-full w-full  p-10">
      <SenfManCelebratingImg
        src={senfManCelebrating}
        alt="Illustration"
      />

      <div className="flex flex-col   gap-5">
        <h3 className="heading-2xl text-center">
          {t("dialogMap:add.successPage.title")}
        </h3>

        <Button
          size="lg"
          className="w-full"
          variant="primary"
          text={t("global:writeAnotherPost")}
          onClick={() => handle.openAddIdea(ideaMap)}
        />
        <Dropdown
          variant="outline"
          text={t("global:shareViaSocialmedia")}
          size="lg"
          className="w-full"
          leadingIcon="share"
          trailingIcon={false}
          items={socialLinks({
            trackLocation: "addIdeaSucessPage",
            path: `${window.location.origin}/projects/${project.projectId}/${data.ideaId}`,
          })}
        />
        <Button
          size="lg"
          className="w-full"
          variant="outline"
          text={t("global:toInfoPage")}
          onClick={() => handle.openInfo()}
        />

       

        {/* {ideaMap?.succcessTitle ? (
          <div className="flex flex-col gap-2">
            <h4 className="body-md-bold">{ideaMap?.publishedTitle}</h4>
            <h4 className="body-md-bold">{ideaMap?.publishedDescription}</h4>
          </div>
        ) : null} */}



   
      
      </div>
    </div>
  );
};

export default Success;
